import { RouteResultPage } from "../../repositories";

export function defaultRoutePage(): RouteResultPage {
  return {
    results: [],
    length: 0,
    hasMore: false
  };
}
